import { useShareDistrictAssignmentResultsMutation } from '@lon/shared/requests';
import { types } from './duck';
import { useShareResultHandler } from './duck/hooks';
import { Modal } from './components';

const ShareDistrictAssignmentResultsModal: React.FC<
  types.ShareDistrictAssignmentResultsModalProps
> = ({ onClose, isOpen, isMultiple = false, studentsData, onCompleted }) => {
  const [handleSubmit, { loading }] = useShareResultHandler({
    useMutation: useShareDistrictAssignmentResultsMutation,
    isMultiple,
    onCompleted,
    studentsData,
  });

  return (
    <Modal
      isMultiple={isMultiple}
      onSubmit={handleSubmit}
      onClose={onClose}
      loading={loading}
      isOpen={isOpen}
      studentName={`${studentsData[0]?.firstName} ${studentsData[0]?.lastName}`}
      withNotes={false}
    />
  );
};

export default ShareDistrictAssignmentResultsModal;
